<template>
  <v-list dense>
    <v-list-item>
      <v-row dense align="center" no-gutters justify="space-between">
        <InventoryTemplateEditorSearch
          v-if="filter.length > 0"
          :tags="filter"
          @search="goToProduct"
        ></InventoryTemplateEditorSearch>
        <InventoryTemplateEditorProductAdder
          v-if="filter.length > 0"
          :tags="filter"
          @add-product="addProduct"
        ></InventoryTemplateEditorProductAdder>
      </v-row>
    </v-list-item>
    <draggable
      v-model="items"
      style="width: 100%;"
      handle=".product-handle"
      group="product"
      @change="changeHandler"
    >
      <v-list-item
        v-for="(item, index) in items"
        :key="item.id"
        :id="`id${item.id}`"
      >
        <v-list-item-action v-show="containsLocalisationTag === true">
          <v-icon class="product-handle" style="cursor: grab;"
            >fa-grip-lines</v-icon
          >
        </v-list-item-action>
        <v-list-item-content>
          <v-row dense align="center" no-gutters>
            <span class="caption mr-3"
              >{{ index + 1 }}{{ index === 0 ? "er" : "e" }}</span
            >
            <span class="text-capitalize">{{ item.nom }}</span>
          </v-row>
        </v-list-item-content>
        <v-list-item-action>
          <InventoryTemplateEditorPositionDialog
            @update="v => updateIndex(item, v)"
          ></InventoryTemplateEditorPositionDialog>
        </v-list-item-action>
      </v-list-item>
    </draggable>
  </v-list>
</template>

<script>
import { api } from "@/api";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
import InventoryTemplateEditorProductAdder from "./InventoryTemplateEditorProductAdder";
import InventoryTemplateEditorSearch from "./InventoryTemplateEditorSearch";
import InventoryTemplateEditorPositionDialog from "./InventoryTemplateEditorPositionDialog";
export default {
  name: "InventoryGridTemplateEditor",
  components: {
    draggable,
    InventoryTemplateEditorProductAdder,
    InventoryTemplateEditorSearch,
    InventoryTemplateEditorPositionDialog
  },
  props: {
    filter: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      "getStoreId",
      "getProducts",
      "getInventoryTagOrders",
      "getTagCategories"
    ])
  },
  data() {
    return {
      items: [],
      localisationTag: null,
      containsLocalisationTag: false
    };
  },
  methods: {
    getItems() {
      this.setContainsLocalisationTag();
      if (this.filter.length > 0) {
        const items = [
          ...this.getProducts.filter(
            x =>
              x.is_deleted === false &&
              x.data !== null &&
              this.filter.every(t => x.data.tags.includes(t))
          )
        ];
        if (this.containsLocalisationTag === false) {
          this.items = items.sort((a, b) => a.nom - b.nom);
        } else {
          this.items = items
            .map(x => {
              const tagOrder = this.getProductTagOrder(x);
              return {
                ...x,
                category_tag_order: tagOrder.order,
                category_tag_order_data: tagOrder
              };
            })
            .sort((a, b) => a.category_tag_order - b.category_tag_order);
        }
      } else {
        return [];
      }
    },
    setContainsLocalisationTag() {
      const localisationTags = [
        ...new Set(
          ...this.getTagCategories
            .filter(x => x.category_type === 1)
            .map(x => x.tags)
        )
      ];
      this.filter.forEach(x => {
        if (localisationTags.includes(x)) {
          this.localisationTag = x;
          this.containsLocalisationTag = true;
        }
      });
    },
    getProductTagOrder(product) {
      const tagOrder = this.getInventoryTagOrders.find(
        x => x.product === product.id && x.tag === this.localisationTag
      );
      if (tagOrder) {
        return tagOrder;
      } else {
        return {
          order: null
        };
      }
    },
    async changeHandler() {},
    async saveOrder() {
      if (
        this.containsLocalisationTag === true &&
        this.localisationTag !== null
      ) {
        const newOrderList = this.items.map(x => {
          if (
            x.category_tag_order_data !== undefined &&
            x.category_tag_order_data.id !== undefined &&
            x.category_tag_order_data.id !== null
          ) {
            const d = {
              ...x.category_tag_order_data,
              order: this.items.findIndex(i => i.id === x.id)
            };
            return d;
          } else {
            const d = {
              store: this.getStoreId,
              product: x.id,
              tag: this.localisationTag,
              order: this.items.findIndex(i => i.id === x.id)
            };
            return d;
          }
        });
        await api.updateInventoryTagOrderBatch({ data: [...newOrderList] });
      }
    },
    updateIndex(item, index) {
      if (Number.isInteger(Number(index))) {
        index = index - 1;
        if (index < 1) index = 0;
        if (index > this.items.length) index = this.items.length;
        this.items = this.items.filter(x => x.id !== item.id);
        this.items.splice(index, 0, item);
      }
    },
    goToProduct(item) {
      if (item) {
        const product = this.items.find(x =>
          x.nom.toLowerCase().includes(item.toLowerCase())
        );
        if (product) {
          this.$vuetify.goTo(`#id${product.id}`, { type: "selector" });
        }
      }
    },
    addProduct(data) {
      const item = data.product;
      let index = data.index - 1;
      if (index < 1) index = 0;
      if (index > this.items.length) index = this.items.length;
      this.items = this.items.filter(x => x.id !== item.id);
      this.items.splice(index, 0, item);
    }
  },
  watch: {
    filter: {
      immediate: true,
      handler: "getItems"
    }
  }
};
</script>

<style></style>
